"use strict"
// ENUMS


/// Translating ImageNames like. DatapointConfig.ImageName to Class
var _IMAGE2CLASS =
{
	// Visualisation Datapoints and Datapoints Set Class
	"Solltemperatur" : 'temp-soll',
	"Isttemperatur" : 'temp-ist',
	"Folder" : 'raum',
	"raeume_102x70" : "raeume",
	"geraete_102x70" : "geraete",
	"geraete-suchen_102x70" : "geraete-suchen",
	"netzwerk_102x70" : "netzwerk",
	"fernwartung_102x70" : "fernwartung",
	"benachrichtigung_102x70" : "benachrichtigung",
	"techniker-settings_102x70" : "techniker-settings",
	"login_102x70" : "login",
	"system-settings_102x70" : "system-settings",
	"favoriten_102x70" : "favoriten",
	"software-update_102x70" : "software-update",
	"software_102x70" : "software",
	"display-settings_102x70" : "display-settings",
	"szene_102x70" : "szene",
	"inbetriebnahme_102x70" : "inbetriebnahme",
	"datum-uhrzeit_102x70" : "datum-uhrzeit",
	"regenerative-energie_102x70" : "regenerative-energie",
	"ladekreis_102x70" : "ladekreis",
	"kaeltekreis_102x70" : "kaeltekreis",
	"hk1_102x70" : "hk1",
	"hk2_102x70" : "hk2",
	"hk3_102x70" : "hk3",
	"start-settings_102x70" : "start-settings",
	"funktionsheizen_102x70" : "funktionsheizen",
	"kuehlsystem_102x70" : "kuehlsystem",
	"hk-info_102x70" : "hk-info",
	"bivalenz-settings_102x70" : "bivalenz-settings",
	"schornsteinfeger_102x70" : "schornsteinfeger",
	"zaehler-status_102x70" : "zaehler-status",
	"zaehler-settings_102x70" : "zaehler-settings",
	"anlagen-konfiguration_102x70" : "anlagen-konfiguration",
	"io-konfiguration_102x70" : "io-konfiguration",
	"pumpen-wartungslauf_102x70" : "pumpen-wartungslauf",
	"frostschutz_102x70" : "frostschutz",
	"alarm-settings_102x70" : "alarm-settings",
	"notbetrieb_102x70" : "notbetrieb",
	"zaehler_102x70" : "zaehler",
	"sensor-kalibrierung_102x70" : "sensor-kalibrierung",
	"handbetrieb_102x70" : "handbetrieb",
	"alarm-historie_102x70" : "alarm-historie",
	"warnung-historie_102x70" : "warnung-historie",
	"effizienz_102x70" : "effizienz",
	"wp-status_102x70" : "wp-status",
	"eingaenge_102x70" : "eingaenge",
	"ausgaenge_102x70" : "ausgaenge",
	"rbg_102x70" : "rbg",
	"kaeltekreis-info_102x70" : "kaeltekreis-info",
	"wp-info_102x70" : "wp-info",
	"software-info_102x70" : "software-info",
	"verdichter_102x70" : "verdichter",
	"bivalenz_102x70" : "bivalenz",
	"twe_102x70" : "twe",
	"heizkreis_102x70" : "heizkreis",
	"temperaturen-werte_102x70" : "temperaturen-werte",
	"sprache_102x70" : "sprache",
	"system-info_102x70" : "system-info",
	"system-status_102x70" : "system-status",
	"geraete-settings_102x70" : "geraete-settings",
	"kaeltekreis-status_102x70" : "kaeltekreis-status",
	"frequenzumformer_102x70" : "frequenzumformer",
	"expansion_102x70" : "expansion",
	"4wegeventil_102x70" : "4wegeventil",
	"abtauen_102x70" : "abtauen",
	"schutzfunktionen_102x70" : "schutzfunktionen",
	"ladekreis-settings_102x70" : "ladekreis-settings",
	"luefter-settings_102x70" : "luefter-settings",
	"pumpen-settings_102x70" : "pumpen-settings",
	"hk1-settings_102x70" : "hk1-settings",
	"heizkurve_102x70" : "heizkurve",
	"hk2-settings_102x70" : "hk2-settings",
	"hk3-settings_102x70" : "hk3-settings",
	"frostschutz-hk_102x70" : "frostschutz-hk",
	"frostschutz-wp_102x70" : "frostschutz-wp",
	"sensoren-alarm-settings_102x70" : "sensoren-alarm-settings",
	"frequenzumformer-alarm-settings_102x70" : "frequenzumformer-alarm-settings",
	"wp-alarm-settings_102x70" : "wp-alarm-settings",
	"notbetrieb-settings_102x70" : "notbetrieb-settings",
	"notbetrieb-konfiguration_102x70" : "notbetrieb-konfiguration",
	"zaehler-reset_102x70" : "zaehler-reset",
	"heizsystem-effizienz_102x70" : "heizsystem-effizienz",
	"twe-effizienz_102x70" : "twe-effizienz",
	"wp-effizienz_102x70" : "wp-effizienz",
	"hk-status_102x70" : "hk-status",
	"smartgrid-status_102x70" : "smartgrid-status",
	"bivalenz-status_102x70" : "bivalenz-status",
	"abtauen-status_102x70" : "abtauen-status",
	"SubSubSubMainImage" : "SubSubSubMainImage",
	"verdichter-status_102x70" : "verdichter-status",
	"verdichter-settings_102x70" : "verdichter-settings",
	"modulation-settings_102x70" : "modulation-settings",
	"oelsumpfheizung_102x70" : "oelsumpfheizung",
	"frequenzumformer-status_102x70" : "frequenzumformer-status",
	"frequenzumformer-settings_102x70" : "frequenzumformer-settings",
	"expansion-status_102x70" : "expansion-status",
	"expansion-settings_102x70" : "expansion-settings",
	"abtauen-settings_102x70" : "abtauen-settings",
	"notbetrieb-pumpen_102x70" : "notbetrieb-pumpen",
	"info_102x70" : "information"

};

// Icons im widget
var _ICONWIDGETICONS =  [

	{
		'Group' : 'Geräte',
		"GroupIcon" : 'geraete',
		'Icons': [
			{'Class':'einfach-schalter'},
			{'Class':'zweifach-schalter'},
			{'Class':'vierfach-schalter'},
			{'Class':'bewegungsmelder'},
			{'Class':'dimmer'},
			{'Class':'dipschalter'},
			{'Class':'fenster-auf'},
			{'Class':'fenster-kontakt'},
			{'Class':'fenster-zu'},
			{'Class':'feuermelder'},
			{'Class':'heizkoerper'},
			{'Class':'heizkoerperregler'},
			{'Class':'jalousieaktor'},
			{'Class':'jalousien'},
			{'Class':'kellergeschoss'},
			{'Class':'kueche-1'},
			{'Class':'kueche-2'},
			{'Class':'licht'},
			{'Class':'lueftung'},
			{'Class':'oelsumpfheizung'},
			{'Class':'rbg'},
			{'Class':'steckdose'},
			{'Class':'stromzaehler'},
			{'Class':'verdichter'},
			{'Class':'wp-compact'},
			{'Class':'wp-dynamic'},
			{'Class':'x-center'},
			{'Class':'x-net-base'},
			{'Class':'x-well-dezentral'},
			{'Class':'x-well-zentral'},
			{'Class':'zaehler'},




		]
	},
	{
		'Group' : 'Favoriten',
		"GroupIcon" : 'favoriten',
		'Icons': [
			{'Class':'benachrichtigung'},
			{'Class':'warnung'},
			{'Class':'favorit'},
			{'Class':'feiertag'},
			{'Class':'kalender'},
			{'Class':'netzwerk'},
			{'Class':'party'},
			{'Class':'sms'},
			{'Class':'statistik'},
			{'Class':'szene'},
			{'Class':'twe'},
			{'Class':'urlaub'},


		]
	},
	{
		'Group' : 'Gebäude',
		"GroupIcon" : 'gebaeude',
		'Icons': [
			{'Class':'abstellraum-1'},
			{'Class':'abstellraum-2'},
			{'Class':'arbeitszimmer'},
			{'Class':'badezimmer-1'},
			{'Class':'badezimmer-2'},
			{'Class':'badezimmer-3'},
			{'Class':'dusche-1'},
			{'Class':'dusche-3'},
			{'Class':'erdgeschoss'},
			{'Class':'esszimmer'},
			{'Class':'garage'},
			{'Class':'garderobe'},
			{'Class':'kinderzimmer-1'},
			{'Class':'kinderzimmer-2'},
			{'Class':'obergeschoss'},
			{'Class':'sauna'},
			{'Class':'schlafzimmer-1'},
			{'Class':'schlafzimmer-2'},
			{'Class':'trainingsraum'},
			{'Class':'treppenhaus'},
			{'Class':'waschmaschine'},
			{'Class':'wc'},
			{'Class':'wintergarten'},
			{'Class':'wohnzimmer-1'},
			{'Class':'wohnzimmer-2'},
			{'Class':'wohnzimmer-3'},
			{'Class':'wohnzimmer-4'},
			{'Class':'wohnzimmer-5'}


		]
	},
	{
		'Group' : 'Temperatur',
		"GroupIcon" : 'temperatur',
		'Icons': [
			{'Class':'bewegung-und-licht-sensor'},
			{'Class':'co2-sensor'},
			{'Class':'licht-sensor'},
			{'Class':'temp-ist'},
			{'Class':'temp-soll'},
			{'Class':'temp-und-feuchte-sensor'},
			{'Class':'temperatur'},
			{'Class':'temperatur-sensor'},
			{'Class':'wasser-sensor'},
			{'Class':'wetterstation'}

		]
	}

];

angular.module('app.configuration.icons', []).//

constant('_IMAGE2CLASS', _IMAGE2CLASS).//

constant('_ICONWIDGETICONS', _ICONWIDGETICONS);